<template>
    <div>
        <b-skeleton-img
            no-aspect
            height="250px"
        />
        <br>

        <div class="text-center my-5">
            <b-skeleton animation="wave" width="35%" class="mx-auto"></b-skeleton>
            <b-skeleton animation="wave" width="25%" class="mx-auto"></b-skeleton>
        </div>

        <b-card class="mx-auto my-5">
            <b-skeleton animation="wave" width="100%"></b-skeleton>
            <b-skeleton animation="wave" width="95%"></b-skeleton>
            <b-skeleton animation="wave" width="70%"></b-skeleton>

            <br>

            <b-skeleton animation="fade" width="100%"></b-skeleton>
            <b-skeleton animation="fade" width="55%"></b-skeleton>

            <br>

            <b-skeleton animation="fade" width="85%"></b-skeleton>
            <b-skeleton animation="fade" width="55%"></b-skeleton>
            <b-skeleton animation="fade" width="70%"></b-skeleton>

            <br>

            <b-skeleton animation="fade" width="100%"></b-skeleton>
            <b-skeleton animation="fade" width="100%"></b-skeleton>
            <b-skeleton animation="fade" width="56%"></b-skeleton>
            <b-skeleton animation="fade" width="97%"></b-skeleton>
            <b-skeleton animation="fade" width="55%"></b-skeleton>
            <b-skeleton animation="fade" width="70%"></b-skeleton>

            <br>

            <b-skeleton animation="fade" width="85%"></b-skeleton>
            <b-skeleton animation="fade" width="55%"></b-skeleton>
            <b-skeleton animation="fade" width="70%"></b-skeleton>

            <br>

            <b-skeleton animation="fade" width="85%"></b-skeleton>
            <b-skeleton animation="fade" width="55%"></b-skeleton>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "KnowledgeAssetLoading"
    };
</script>

<style scoped>
.card {
    max-width: 45.688rem;
}
</style>